export default __webpack_public_path__ + "static/media/img--interiors-6.1fe182b2.jpg";